import React, { useEffect, useMemo, useState } from 'react';
import './master.css';
import ApiService from '../../../services/apiService';
import ApiService2 from '../../../../INVENTORY/services/apiService';
import userManagement from '../../../services/userManagement';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { hasPermission } from '../../../services/roleService';
import { useNavigate } from 'react-router-dom';

const AddSubCategory = () => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [glAccount, setGlAccount] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    subcategory: '',
    category: '', // recordId (UI)
    catcode: '', // ✅ API needs this
    glAccountCode: '',
    glAccountName: '',
  });

  useEffect(() => {
    GetCategory();
    GetSubCategory();
    GetAccount();
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    setPermissions(storedPermissions);
  }, []);

  const checkPermission = (moduleName, action) => hasPermission(moduleName, action, permissions);

  // NOTE: you had "|| true" which makes permissions always true. Keeping your behavior.
  const canCreateSubCategory = checkPermission('SubCategory Master', 'create') || true;
  const canEditSubCategory = checkPermission('SubCategory Master', 'edit') || true;
  const canDeleteSubCategory = checkPermission('SubCategory Master', 'delete') || true;

  const handleInputChange = (e) => setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const GetCategory = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_CATEGORY_MASTER');

      const filtered = (res?.data?.result || []).filter((item) => item?.active === 1);
      setCategories(filtered);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const GetSubCategory = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_SUB_CATEGORY_MASTER');
      setSubCategories(res?.data?.result || []);
    } catch (error) {
      console.error('Error fetching Sub-category data:', error);
    }
  };

  const GetAccount = async () => {
    try {
      const apiService = new ApiService2();
      const params = new URLSearchParams();
      params.append('PageNo', 1);
      params.append('PageSize', 50);
      const response = await apiService.getApiParamater('GET_ACCOUNTS', `?${params.toString()}`);
      setGlAccount(response?.data?.result || []);
    } catch (error) {
      console.error('Error fetching GL ACCOUNT data:', error);
    }
  };

  // ✅ Category options (UI uses recordId, API needs catCode)
  const categoryOptions = useMemo(
    () =>
      (categories || []).map((c) => ({
        value: c.recordId, // UI selection key
        label: c.catName,
        data: c, // keep full row to access catCode + accounts etc.
      })),
    [categories]
  );

  const handleCategoryChange = (opt) => {
    const c = opt?.data;

    setFormData((prev) => ({
      ...prev,
      category: opt?.value ?? '',
      catcode: c?.catCode ?? '', // ✅ store for API
      // If your category itself holds default accounts, you can prefill here too:
      // glAccountCode: c?.inventoryAccountCode ?? '',
      // glAccountName: '',
    }));
  };

  const glOptions = useMemo(
    () =>
      (glAccount || []).map((gl) => ({
        value: gl,
        label: gl.accountName,
      })),
    [glAccount]
  );

  const handleGLAccounts = (selectedOption) => {
    const gl = selectedOption?.value;
    setFormData((prev) => ({
      ...prev,
      glAccountCode: gl?.accountCode ?? '',
      glAccountName: gl?.accountName ?? '',
    }));
  };

  // ✅ CREATE payload matches your API contract
  const CreateSubCategory = async () => {
    const userId = await userManagement.getUserId();

    if (!formData?.catcode) return toast.warning('Please Select Category');
    if (!formData?.subcategory?.trim()) return toast.warning('Please Enter SubCategory Name');

    try {
      const body = {
        recordid: 0,
        subcatcode: formData.subcategory.trim(), // if you don't have separate code input
        subcatname: formData.subcategory.trim(),
        catcode: formData.catcode,

        active: 1,
        adduser: String(userId ?? ''),

        // Map your selected GL to whichever fields you actually use:
        inventoryAccountCode: formData.glAccountCode ?? '',
        grnAccountCode: '',
        invoiceAccountCode: '',
        cgsAccountCode: '',
        adjustmentAccountCode: '',
        wastageAccountCode: '',
        workInProgressAccountCode: '',
        issueAccountCode: '',

        isActive: true,
        isEditable: 1,
      };

      const apiService = new ApiService();
      const res = await apiService.post('CREATE_SUBCATEGORY_MASTER', body);

      if (res?.data?.statusCode === 201) {
        toast.success('Sub-Category Created Successfully');
        GetSubCategory();
        setFormData({
          subcategory: '',
          category: '',
          catcode: '',
          glAccountCode: '',
          glAccountName: '',
        });
      } else if (res?.data?.statusCode === 208) {
        toast.warning(res?.data?.message);
      } else {
        toast.error(res?.data?.message || 'Failed to create subcategory');
      }
    } catch (error) {
      console.error('Error creating subcategory:', error);
      toast.error('Error creating subcategory');
    }
  };

  // NOTE: these update/delete parts depend on your API contract for update/delete.
  // Keeping as-is but you likely need to align fields (recordid/subcatname/catcode etc.)
  const deleteSubCat = async (id) => {
    try {
      const apiService = new ApiService();
      const body = { id: parseInt(id, 10) };
      const res = await apiService.delete('DELETE_SUBCATEGORY', { data: body });
      if (res?.data?.statusCode === 204) {
        toast.success('SubCategory Deleted Successfully');
        GetSubCategory();
      }
    } catch (error) {
      console.error('Error deleting SubCategory:', error);
    }
  };

  const handleUpdatesubCategory = async (subCategory, newActiveStatus) => {
    try {
      const apiService = new ApiService();
      const catData = {
        id: subCategory?.id,
        categoryId: subCategory?.categoryId,
        name: subCategory?.name,
        loggedInUserId: subCategory?.loggedInUserId,
        active: newActiveStatus,
      };
      const res = await apiService.put(`UPDATE_SUBCATEGORY`, catData);
      if (res?.data?.statusCode === 200) {
        toast.success('SubCategory updated successfully!');
        GetSubCategory();
      } else {
        toast.error('Failed to update SubCategory. Please try again!');
      }
    } catch (error) {
      console.error('Error updating SubCategory:', error);
    }
  };

  const handleSwitchChange = async (subCategory, newActiveStatus) => {
    try {
      await handleUpdatesubCategory(subCategory, newActiveStatus);
    } catch (error) {
      console.error('Error updating SubCategory:', error);
    }
  };

  return (
    <div className="p-5 container">
      <button className="addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="catlist">
        <div className="py-3 row">
          <div className="col">
            <label htmlFor="validationCustom04" className="form-label">
              Select category *
            </label>

            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5' : null,
                  color: '#000',
                  ':hover': { backgroundColor: '#F5F5F5', color: '#000' },
                }),
              }}
              value={categoryOptions.find((o) => o.value === formData.category) || null}
              onChange={handleCategoryChange}
              options={categoryOptions}
              placeholder="Select Category"
            />
          </div>

          <div className="col">
            <label htmlFor="validationCustom01" className="form-label">
              Type Subcategory *
            </label>
            <input
              type="text"
              className="p-2 form-control"
              id="validationCustom01"
              name="subcategory"
              value={formData.subcategory}
              onChange={handleInputChange}
              disabled={canCreateSubCategory === true ? false : true}
              placeholder="Enter SubCategory Name"
              required
            />
          </div>

          <div className="col">
            <label htmlFor="validationCustom04" className="form-label">
              Select GL Account *
            </label>

            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5' : null,
                  color: '#000',
                  ':hover': { backgroundColor: '#F5F5F5', color: '#000' },
                }),
              }}
              value={glOptions.find((o) => o.label === formData.glAccountName) || null}
              onChange={handleGLAccounts}
              options={glOptions}
              isDisabled={canCreateSubCategory === true ? false : true}
              placeholder="Select GL Account"
            />
          </div>
        </div>

        <div className="row pt-3">
          <div className="end">
            {canCreateSubCategory === true ? (
              <button className="addItem-btn" onClick={CreateSubCategory}>
                Save
              </button>
            ) : (
              <button className="addItem-btn" style={{ cursor: 'not-allowed' }} disabled>
                Save
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="col-lg-4 mb-3 mt-5 pt-3">
        <input type="Search" className="form-control" id="validationCustom01" placeholder="Search subcategory" required />
      </div>

      <div className="catlist p-5 table-responsive">
        <table className="table table-striped mt-3">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Category</th>
              <th scope="col">Subcategories</th>
              <th scope="col">Account Name</th>
              <th scope="col">Action</th>
            </tr>
          </thead>

          <tbody>
            {subCategories?.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">
                  No SubCategory found
                </td>
              </tr>
            ) : (
              subCategories?.map((item, index) => (
                <tr key={item?.recordid ?? item?.id ?? index}>
                  <th scope="row">{index + 1}</th>

                  {/* These field names depend on your GET_SUB_CATEGORY_MASTER response */}
                  <td>{item.categoryName ?? item.catname ?? item.catcode ?? '-'}</td>
                  <td>{item?.name ?? item?.subcatname ?? '-'}</td>
                  <td>{item?.glAccountName ?? item?.inventoryAccountCode ?? '-'}</td>

                  <td>
                    <div className="d-flex text-center">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id={`flexSwitchCheck${item?.recordid ?? item?.id ?? index}`}
                          checked={Boolean(item.active ?? item.isActive)}
                          onChange={(e) => handleSwitchChange(item, e.target.checked)}
                          disabled={canEditSubCategory === true ? false : true}
                        />
                      </div>
                    </div>
                  </td>

                  {/* If you want delete/edit icons later you can use canDeleteSubCategory, etc. */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddSubCategory;
